<template>
    <div class="card">
        <header class="card-header">
            <p class="card-header-title">Inland Cost:</p>
            <a href="#" class="card-header-icon">
              <span class="icon">
                <i class="fas fa-truck"></i>
              </span>
            </a>
        </header>
        <div class="">
            <div class="content center">
                <table class="table">
                    <tbody>
                    <tr>
                        <th>Yokohama/Kawasaki:</th>
                        <td class="has-text-danger">{{ yokohama }}</td>
                    </tr>
                    <tr>
                        <th>Osaka/Kobe:</th>
                        <td class="has-text-danger">{{ osaka }}</td>
                    </tr>
                    <tr>
                        <th>Nagoya:</th>
                        <td class="has-text-danger">{{ nagoya }}</td>
                    </tr>
                    <tr>
                        <th>Hakata:</th>
                        <td class="has-text-danger">{{ hakata }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import apiInlandPrice from './../../../../api/apiInlandPrice'
    import numeral from 'numeral'
    export default {
        props: ['lot'],
        data() {
            return {
                yokohama: '',
                osaka: '',
                nagoya: '',
                hakata: ''
            }
        },
        methods: {
            getPriceNumber(value) {
                return value !== null ? numeral(value).format("0,0") : 'NaN'
            }
        },
        created() {
            let query = {
                auction: this.lot.auction_name
            }

            apiInlandPrice
                .requestAuctionDeliveryPrices(query)
                .then((response) => {
                    this.yokohama = response.data.yokohama_sales
                    this.osaka = response.data.osaka_sales
                    this.nagoya = response.data.nagoya_sales
                    this.hakata = response.data.hakata_sales
                    console.log(this.hakata)
                })
                .catch((error) => {
                    console.log(error)
                })
        }

    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Cars/Car/Details/InlandCost.vue